/**
 * Draft/publish readiness warnings for PointUI — project settings context.
 * Invoked via uiRegistry (`point`); inspects annotationUI.config only.
 */

import { validatePointConfig } from './pointModel';

export function getPointConfigPublishWarnings(annotationUI) {
    const issues = validatePointConfig(annotationUI?.config);
    return issues.map((i) => i.message);
}

